import { __decorate } from "tslib";
// Core
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { required, maxLength } from 'vuelidate/lib/validators';
// Extends
import { validationMixin } from 'vuelidate';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import CategoryTreeMixin from '@/helpers/vue_mixins/v3/CategoryTreeMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
// Children
import BaseTextArea from '@/components/v2/BaseTextArea';
import CategoryPicker from '@/components/v3/CategoryPicker.vue';
import MoreInfo from '@/components/v3/MoreInfo.vue';
import SwitchTransition from '@/components/page_transition/Switch.vue';
// Models / Helpers
import { CategoryTree } from '@/helpers/constants/CategoryTree';
// Queries / Mutations
import PromptContextQuery from '@/plugins/graphql/queries/v3/fetch-prompt-context.gql';
/**
 * <class>
 * @author Jan Canicon <jan@gorated.ph>
 *                     <jancanicon.work@gmail.com>
 * @since Version {x.xx.x}
 *
 * Docs: <url>
 */
let ExplainerStoreDetails = class ExplainerStoreDetails extends Mixins(validationMixin, ViewportSizeMixin, CategoryTreeMixin, FormValidationsMixin) {
    constructor() {
        super(...arguments);
        this.categoryOptions = CategoryTree;
        this.form = {
            categoryTree: this.baseCategories(),
            businessDescription: null,
        };
        this.expanded = [false, true];
    }
    get hasErrorAndInPreview() {
        return this.$v.$invalid && !this.expanded[0];
    }
    created() {
        if (this.formData) {
            this.form = this.formData;
            this.$emit('onLoaded');
        }
    }
};
__decorate([
    Prop({ type: Object, default: null })
], ExplainerStoreDetails.prototype, "formData", void 0);
ExplainerStoreDetails = __decorate([
    Component({
        components: {
            BaseTextArea,
            CategoryPicker,
            MoreInfo,
            SwitchTransition,
        },
        apollo: {
            promptContext: {
                query: PromptContextQuery,
                variables() {
                    return {
                        appUuid: this.$store.state.appUUID,
                    };
                },
                update({ app }) {
                    this.form.categoryTree = this.buildCategoryTree(app.categoryTree);
                    this.form.businessDescription = app.businessDescription;
                    this.$v.$touch();
                    this.$emit('onLoaded');
                },
                skip() {
                    return !this.$store.state.appUUID || this.formData;
                },
            },
        },
        validations: {
            form: {
                categoryTree: {
                    required() {
                        const { categoryTree } = this.form;
                        const keys = Object.keys(categoryTree);
                        return keys.filter((key) => categoryTree[key].primaryOption === true).length > 0;
                    },
                },
                businessDescription: {
                    required,
                    maxLength: maxLength(800),
                },
            },
        },
    })
], ExplainerStoreDetails);
export default ExplainerStoreDetails;
